import classNames from "classnames/bind";

import styles from './MenuIcon.module.scss';
const cx = classNames.bind(styles);

export default function MenuIcon(props: { active: boolean; onClick: () => void }) {
  const { active, onClick } = props;
  return (
    <button className={cx("menu-icon", { active })} onClick={onClick} aria-label="Menu" aria-expanded={active}>
      <div className={cx("menu-icon-box")}>
        <div className={cx("menu-icon-inner")}></div>
      </div>
    </button>
  );
}